import type { Team } from '@atlaskit/user-picker/types';

import { config } from '../config';
import { UNKNOWN_TEAM } from './constants';

type LegionRequest = {
	baseUrl?: string;
	id: string;
	siteId?: string;
};

export type LegionTeamState = 'ACTIVE' | 'DISBANDED' | 'PURGED';

export type LegionResponse = {
	id: string;
	displayName: string;
	smallAvatarImageUrl: string;
	state?: LegionTeamState;
};

const transformTeam = (team: LegionResponse, id: string): Team => {
	return {
		id,
		name: team.displayName,
		type: 'team',
		avatarUrl: team.smallAvatarImageUrl,
		...(team.state && { state: team.state }), // State to determine if the team is active/disbanded
	};
};

const hydrateTeamFromLegion = (request: LegionRequest): Promise<Team> => {
	const url = config.getTeamsUrl(request.id, request.baseUrl, request.siteId);

	return fetch(url, {
		method: 'GET',
		credentials: 'include',
		headers: {
			'content-type': 'application/json',
		},
	})
		.then((response: Response) => {
			if (response.status === 200) {
				return response.json();
			}

			return Promise.reject({
				message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`,
			});
		})
		.then((response: LegionResponse) => {
			return transformTeam(response, request.id);
		})
		.catch(() => ({
			...UNKNOWN_TEAM, // on network error, return original team with label 'Unknown'
			id: request.id,
		}));
};

export default hydrateTeamFromLegion;
